import { Swiper, Navigation } from 'swiper/core';
import slideInTitle from './modules/slideInTitle'
import slideInBlock from './modules/slideInBlock'
import slideInFeatureBg from './modules/slideInFeatureBg'

Swiper.use([Navigation]);

const bgSlideBlock = slideInBlock();
const bgTextSlideBlock = slideInFeatureBg();

export default () => {

  const f = {};
  const init = () => {
    console.log('init featureSec');
    f.root = document.getElementById('feature');
    if (!f.root) {
      return;
    }

    f.root.querySelector('.at-feature__bg').style.opacity = '0';
    buildSwiper();
    buildSlideBlock();
    slideBgText();
  }

  const isPC = window.matchMedia('(min-width: 768px)').matches;
  const swiperOption = {
    width: calcWidthLength(isPC ? 440 : 280),
    spaceBetween: 0,
    loop: true,
    loopAdditionalSlides: 2,
    navigation: {
      nextEl: '.at-feature__btn._next',
      prevEl: '.at-feature__btn._prev'
    }
  };
  const buildSwiper = () => {
    f.container = f.root.querySelector('.at-feature__container');
    const nextBtn = f.root.querySelector('.at-feature__btn._next')
    const prevBtn = f.root.querySelector('.at-feature__btn._prev')
    swiperOption.navigation = {
      nextEl: nextBtn,
      prevEl: prevBtn
    }
    f.swiper = new Swiper(f.container, swiperOption);
    window.addEventListener('resize', resize);
  }

  let timerId = null;
  const resize = () => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      f.swiper.destroy(true, true);
      swiperOption.width = calcWidthLength(isPC ? 440 : 280);
      f.swiper = new Swiper(f.container, swiperOption);
      timerId = null;
    }, 0);
  }

  function calcWidthLength (num) {
    const ww = window.innerWidth;
    // 1rem の pixel 計算
    let ROOTREM = 0;
    if (ww > 1280) {
      ROOTREM = 10 + 2 * (ww - 1280) / 400;
    } else if (ww >= 768) {
      ROOTREM = ww * .78125 / 100;
    } else {
      ROOTREM = 10 + 8 * (ww - 375) / 649;
    }
    return (num * ROOTREM / 10) | 0;
  }

  const buildSlideBlock = () => {
    bgSlideBlock.init(f.root.querySelector('.at-feature__bg'));

    slideInTitle().build(f.root)
      .then(() => {
        bgSlideBlock.move();
      });
  }


  // Background Text Animation
  const buildSlideBgText = () => {
    bgTextSlideBlock.init(f.root.querySelector('.at-feature__bg'));

    slideInTitle().build(f.root)
      .then(() => {
        bgTextSlideBlock.move();
      });
  }

  // Background Text Animation Observer
  const slideBgText = () => {
    const target = document.querySelector('.at-feature__bg');
    const option = {
      threshold: [0.5]
    };

    const callback = function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              target.style.opacity = '1';
              buildSlideBgText();
              observer.unobserve(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(callback, option);
    observer.observe(target);
  }


  init();

  return {}
}
